import type {
  AppState,
  AppUser,
  ArchiveItem,
  Carrier,
  CarrierDocument,
  CarrierDocumentFolder,
  CustomRole,
  Driver,
  NavKey,
  NotificationItem,
  OperationalRequest,
  Role,
  RoutePlan,
  ScheduleEntry,
  SessionUser,
  TaskItem,
  Vehicle
} from "../types";

export const ADMIN_LOGIN = "Stobima";
export const ADMIN_PASSWORD = "TEST123";

export const roles: Role[] = [
  "administrator",
  "kierownik",
  "st. dyspozytor",
  "podglad",
  "przewoznik",
  "kierowca",
  "zewnetrzny"
];

export const roleLabels: Record<string, string> = {
  administrator: "administrator",
  kierownik: "kierownik",
  "st. dyspozytor": "st. dyspozytor",
  podglad: "podgląd",
  przewoznik: "przewoźnik",
  kierowca: "kierowca",
  zewnetrzny: "użytkownik zewnętrzny"
};

export const roleAccess: Record<string, NavKey[]> = {
  administrator: [
    "pulpit",
    "grafik",
    "dodajWpis",
    "dodajTrase",
    "szukaj",
    "braki",
    "kierowcy",
    "przewoznicy",
    "trasy",
    "zgloszenia",
    "powiadomienia",
    "archiwum",
    "administracja"
  ],
  kierownik: ["pulpit", "grafik", "dodajWpis", "dodajTrase", "szukaj", "braki", "kierowcy", "przewoznicy", "trasy", "zgloszenia", "powiadomienia", "archiwum"],
  "st. dyspozytor": ["pulpit", "grafik", "szukaj", "braki", "kierowcy", "przewoznicy", "trasy", "zgloszenia", "powiadomienia"],
  podglad: ["pulpit", "grafik", "szukaj", "kierowcy", "przewoznicy", "trasy"],
  przewoznik: ["pulpit", "grafik", "szukaj", "kierowcy", "zgloszenia", "powiadomienia"],
  kierowca: ["pulpit", "grafik", "powiadomienia"],
  zewnetrzny: ["pulpit", "zgloszenia", "powiadomienia"]
};

export const weekDays = ["Pon", "Wt", "Śr", "Czw", "Pt", "Sob", "Nd"];

const carriers: Carrier[] = [
  { id: "car-sng", name: "SNG Transport", email: "operacje@sng.local", phone: "500 100 200", notes: "Główny przewoźnik", address: "Aleja Ofiar Terroryzmu 11 Września 12, 92-410 Łódź", contactPerson: "Dyspozytor SNG", contactPhone: "500 100 200", cooperationType: "Współpraca stała", active: true },
  { id: "car-north", name: "North Line", email: "kontakt@north.local", phone: "501 200 300", notes: "Obsługa tras północnych", address: "Łódź", contactPerson: "Koordynator North", contactPhone: "501 200 300", cooperationType: "Współpraca stała", active: true },
  { id: "car-baltic", name: "Baltic Cargo", email: "dyspozytor@baltic.local", phone: "502 300 400", notes: "Rezerwa weekendowa", address: "Szczecin", contactPerson: "Koordynator Baltic", contactPhone: "502 300 400", cooperationType: "Rezerwa", active: true }
];

const drivers: Driver[] = [
  {
    id: "drv-001",
    name: "Marek Wolski",
    type: "Food",
    active: true,
    carrierId: "car-sng",
    vehicleId: "veh-001",
    privatePhone: "600 101 101",
    workPhone: "700 101 101",
    phoneId: "TEL-001",
    awizacja: "AW-42",
    vehicle: "Renault Master",
    registration: "WPR 4827K",
    pallets: 8,
    capacityKg: 1200,
    city: "Warszawa",
    postalCode: "02-001",
    address: "Magazyn 4",
    notes: "Stała trasa poranna",
    awizacjaOd1: "08:00",
    awizacjaOd2: "12:00"
  },
  {
    id: "drv-002",
    name: "Olga Król",
    type: "Food Bus",
    active: true,
    carrierId: "car-north",
    vehicleId: "veh-002",
    privatePhone: "600 202 202",
    workPhone: "700 202 202",
    phoneId: "TEL-002",
    awizacja: "AW-17",
    vehicle: "Iveco Daily",
    registration: "EL 7702A",
    pallets: 10,
    capacityKg: 1500,
    city: "Łódź",
    postalCode: "90-001",
    address: "Rampa B",
    notes: "Może obsłużyć Food Bus",
    awizacjaOd1: "09:00",
    awizacjaOd2: "13:00"
  },
  {
    id: "drv-003",
    name: "Adam Piasecki",
    type: "Dedyk",
    active: true,
    carrierId: "car-sng",
    vehicleId: "veh-003",
    privatePhone: "600 303 303",
    workPhone: "700 303 303",
    phoneId: "TEL-003",
    awizacja: "AW-09",
    vehicle: "Mercedes Sprinter",
    registration: "SK 3189M",
    pallets: 6,
    capacityKg: 900,
    city: "Katowice",
    postalCode: "40-001",
    address: "Punkt C",
    notes: "Dedykowane kursy zagraniczne",
    awizacjaOd1: "07:30",
    awizacjaOd2: "11:30"
  },
  {
    id: "drv-004",
    name: "Karol Baran",
    type: "Food",
    active: false,
    carrierId: "car-baltic",
    vehicleId: "veh-004",
    privatePhone: "600 404 404",
    workPhone: "700 404 404",
    phoneId: "TEL-004",
    awizacja: "AW-22",
    vehicle: "Ford Transit",
    registration: "ZS 1184T",
    pallets: 8,
    capacityKg: 1100,
    city: "Szczecin",
    postalCode: "70-001",
    address: "Baza Północ",
    notes: "Nieaktywny do potwierdzenia badań",
    awizacjaOd1: "10:00",
    awizacjaOd2: "14:00"
  }
];

const vehicles: Vehicle[] = [
  {
    id: "veh-001",
    carrierId: "car-sng",
    model: "Renault Master",
    name: "Renault Master WPR 4827K",
    registration: "WPR 4827K",
    type: "Furgon",
    loadKg: 1200,
    pallets: 8,
    active: true,
    mileageKm: 184320,
    mainDriverId: "drv-001",
    fuel: "Diesel",
    gearbox: "Manualna",
    dmcKg: 3500,
    productionYear: "2022",
    vin: "SNGRENAULTMASTER001",
    notes: "Auto przypisane do tras Food"
  },
  {
    id: "veh-002",
    carrierId: "car-north",
    model: "Iveco Daily",
    name: "Iveco Daily EL 7702A",
    registration: "EL 7702A",
    type: "Food Bus",
    loadKg: 1500,
    pallets: 10,
    active: true,
    mileageKm: 126800,
    mainDriverId: "drv-002",
    fuel: "Diesel",
    gearbox: "Manualna",
    dmcKg: 3500,
    productionYear: "2021",
    vin: "SNGIVECO002",
    notes: "Obsługa Food Bus"
  },
  {
    id: "veh-003",
    carrierId: "car-sng",
    model: "Mercedes Sprinter",
    name: "Mercedes Sprinter SK 3189M",
    registration: "SK 3189M",
    type: "Dedyk",
    loadKg: 900,
    pallets: 6,
    active: true,
    mileageKm: 93400,
    mainDriverId: "drv-003",
    fuel: "Diesel",
    gearbox: "Automat",
    dmcKg: 3200,
    productionYear: "2023",
    vin: "SNGSPRINTER003",
    notes: "Dedykowane kursy zagraniczne"
  },
  {
    id: "veh-004",
    carrierId: "car-baltic",
    model: "Ford Transit",
    name: "Ford Transit ZS 1184T",
    registration: "ZS 1184T",
    type: "Furgon",
    loadKg: 1100,
    pallets: 8,
    active: false,
    mileageKm: 211900,
    mainDriverId: "drv-004",
    fuel: "Diesel",
    gearbox: "Manualna",
    dmcKg: 3300,
    productionYear: "2020",
    vin: "SNGTRANSIT004",
    notes: "Pojazd czasowo nieaktywny"
  }
];

const carrierDocuments: CarrierDocument[] = [];
const carrierDocumentFolders: CarrierDocumentFolder[] = [
  { id: "cdf-general-sng", carrierId: "car-sng", name: "Ogólne", createdAt: "2026-05-16 00:00" }
];

const routes: RoutePlan[] = [
  {
    id: "rou-001",
    name: "Warszawa -> Poznań",
    cityFrom: "Warszawa",
    cityTo: "Poznań",
    defaultStart: "06:00",
    defaultEnd: "14:00",
    serviceType: "Food",
    requiredDrivers: 2,
    driverId: "drv-001",
    points: [
      { shopNo: "101", city: "Warszawa", code: "00-001", type: "Magazyn", address: "Magazyn centralny", notes: "Awizacja 06:00" },
      { shopNo: "102", city: "Poznań", code: "60-001", type: "Sklep", address: "Punkt odbioru", notes: "Dostawa" }
    ]
  },
  {
    id: "rou-002",
    name: "Łódź -> Gdańsk",
    cityFrom: "Łódź",
    cityTo: "Gdańsk",
    defaultStart: "14:00",
    defaultEnd: "22:00",
    serviceType: "Food Bus",
    requiredDrivers: 1,
    driverId: "drv-002",
    points: [
      { shopNo: "201", city: "Łódź", code: "90-001", type: "Magazyn", address: "Rampa B", notes: "Awizacja 14:00" },
      { shopNo: "202", city: "Gdańsk", code: "80-001", type: "Sklep", address: "Punkt północ", notes: "Dostawa" }
    ]
  },
  {
    id: "rou-003",
    name: "Dedyk Berlin",
    cityFrom: "Katowice",
    cityTo: "Berlin",
    defaultStart: "12:00",
    defaultEnd: "22:00",
    serviceType: "Dedyk",
    requiredDrivers: 1,
    driverId: "drv-003",
    points: [
      { shopNo: "301", city: "Katowice", code: "40-001", type: "Załadunek", address: "Punkt C", notes: "Awizacja 12:00" },
      { shopNo: "302", city: "Berlin", code: "10115", type: "Rozładunek", address: "Berlin", notes: "Dedyk" }
    ]
  },
  { id: "rou-004", name: "Szczecin -> Wrocław", cityFrom: "Szczecin", cityTo: "Wrocław", defaultStart: "22:00", defaultEnd: "04:00", serviceType: "Food", requiredDrivers: 1 }
];

const schedule: ScheduleEntry[] = [
  { id: "sch-001", date: "2026-05-18", driverId: "drv-001", carrierId: "car-sng", routeId: "rou-001", status: "P", start: "06:00", end: "14:00", notes: "Potwierdzony" },
  { id: "sch-002", date: "2026-05-18", driverId: "drv-002", carrierId: "car-north", routeId: "rou-002", status: "PLAN", start: "14:00", end: "22:00", notes: "Czeka na potwierdzenie" },
  { id: "sch-003", date: "2026-05-19", driverId: "drv-003", carrierId: "car-sng", routeId: "rou-003", status: "P", start: "12:00", end: "22:00", notes: "Dokumenty OK" },
  { id: "sch-004", date: "2026-05-20", carrierId: "car-baltic", routeId: "rou-004", status: "BRAK", start: "22:00", end: "04:00", notes: "Brak kierowcy" },
  { id: "sch-005", date: "2026-05-21", driverId: "drv-001", carrierId: "car-sng", routeId: "rou-001", status: "U", start: "06:00", end: "14:00", notes: "Urlop po kursie" },
  { id: "sch-006", date: "2026-05-22", driverId: "drv-002", carrierId: "car-north", routeId: "rou-002", status: "W", start: "14:00", end: "22:00", notes: "Wolne" }
];

const requests: OperationalRequest[] = [
  {
    id: "REQ-1001",
    type: "BRAK_KIEROWCY",
    status: "oczekuje",
    priority: "wysoki",
    sender: "North Line",
    target: "Dyspozycja",
    subject: "Brak obsady na zmianę nocną",
    description: "Potrzebny kierowca na 22:00-04:00, trasa rezerwowa.",
    createdAt: "2026-05-16 09:20"
  },
  {
    id: "REQ-1002",
    type: "ZMIANA_DANYCH",
    status: "oczekuje",
    priority: "normalny",
    sender: "Olga Król",
    target: "Kierowcy",
    subject: "Aktualizacja telefonu służbowego",
    description: "Nowy numer służbowy do zatwierdzenia przez administratora.",
    createdAt: "2026-05-16 10:05"
  }
];

const notifications: NotificationItem[] = [
  { id: "not-001", recipient: "WSZYSCY", message: "Grafik na tydzień 20 jest gotowy do weryfikacji.", createdAt: "2026-05-16 08:15", read: false },
  { id: "not-002", recipient: "ROLA:st. dyspozytor", message: "Sprawdź braki kierowców na zmianie nocnej.", createdAt: "2026-05-16 09:30", read: false }
];

const archive: ArchiveItem[] = [
  { id: "arc-001", category: "Raport dzienny", title: "Raport grafiku 2026-05-11", owner: "Stobima", archivedAt: "2026-05-11 20:47" },
  { id: "arc-002", category: "Zmiana danych", title: "Aktualizacja kart kierowców", owner: "administrator", archivedAt: "2026-05-12 19:49" }
];

const tasks: TaskItem[] = [
  {
    id: "task-001",
    title: "Uzupełnij braki na aktualny tydzień",
    assignedTo: ADMIN_LOGIN,
    createdBy: ADMIN_LOGIN,
    due: "today",
    priority: "wysoki",
    completed: false,
    createdAt: "2026-05-16 08:00"
  },
  {
    id: "task-002",
    title: "Sprawdź Food na jutro",
    assignedTo: "dyspozytor",
    createdBy: ADMIN_LOGIN,
    due: "tomorrow",
    priority: "normalny",
    completed: false,
    createdAt: "2026-05-16 08:05"
  }
];

export function createInitialAppState(): AppState {
  const users: AppUser[] = [
    {
      id: "usr-admin",
      login: ADMIN_LOGIN,
      name: "Stobima",
      role: "administrator",
      password: ADMIN_PASSWORD,
      status: "aktywny",
      createdAt: "2026-05-16 00:00"
    }
  ];

  return {
    users,
    carriers: [],
    drivers: [],
    vehicles: [],
    carrierDocuments: [],
    carrierDocumentFolders: [],
    routes: [],
    schedule: [],
    requests: [],
    notifications: [],
    archive: [],
    routeTypes: ["Food", "Dedyk", "Food Bus"],
    pointTypes: ["Sklep", "Magazyn", "Załadunek", "Rozładunek"],
    customRoles: [],
    tasks: [],
    notes: []
  };
}

export function authenticateUser(users: AppUser[], login: string, password: string): SessionUser | null {
  const normalizedLogin = normalizeLogin(login);
  const account = users.find((user) => normalizeLogin(user.login) === normalizedLogin);

  if (!account || account.status !== "aktywny" || account.password !== password) {
    return null;
  }

  return {
    id: account.id,
    login: account.login,
    name: account.name,
    role: account.role,
    carrierId: account.carrierId
  };
}

export function normalizeLogin(value: string) {
  return value.trim().toLowerCase();
}

export function getAllRoles(customRoles: CustomRole[] = []) {
  return [
    ...roles.map((role) => ({ name: role, label: roleLabels[role] ?? role, access: roleAccess[role] ?? [] })),
    ...customRoles.map((role) => ({ name: role.name, label: role.name, access: role.access }))
  ];
}

export function canOpen(user: SessionUser, view: NavKey, customRoles: CustomRole[] = []) {
  const customRole = customRoles.find((role) => role.name === user.role);
  return (customRole?.access ?? roleAccess[user.role] ?? []).includes(view);
}
